import React, { useState, MouseEvent } from 'react';
import { observer } from 'src/utils/mobx-react';
import classNames from 'classnames';
import { AppState, useAppStateContext } from 'src/AppState/AppState';

class EventsTriggerState {
    constructor(readonly appState: AppState) {
    }
    open = (e: MouseEvent) => {
        e.preventDefault();
        const lastEvent = this.appState.sportsbookState.eventPageState.lastEvent;
        if (lastEvent !== undefined) {
            this.appState.reduxAction.onOpenEventRequest(lastEvent);
        }
    }
}

export const EventsTrigger = observer('EventsTrigger', () => {
    const appState = useAppStateContext();
    const {sportsbookState: {eventPageState}, routerBackoffice} = appState;
    const [state] = useState(() => new EventsTriggerState(appState));
    const route = routerBackoffice.getValueString('events');

    const className = classNames([
        'events-trigger',
        { 'events-trigger-hidden': route || eventPageState.savedEventsCount === 0 }
    ]);

    return (<a href='#' className={ className } onClick={ state.open }>
        <strong>{ eventPageState.savedEventsCount }</strong>
                events
    </a>);
});
